export const requiredVaccination = {
    title: 'Rokottaminen',
    type: 'vaccinations'
};